export function trim(str) {
  return String.prototype.trim.call(str);
}

export function isType(arg, type) {
  return Object.prototype.toString.call(arg) === "[object " + type + "]";
}

export function isWeixin() {
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
}

export function getUrlparam() {
  let _parms = {};
  let query = location.search.substring(1).split('&');
  for (let i = 0; i < query.length; i++) {
    let pos = query[i].split('=');
    if (pos[0]) {
      _parms[pos[0]] = pos[1] ? pos[1] : '';
    }
  }
  if (isEmpty(_parms)) {
     return null;
    // window.history.back(-1);
  }
  return _parms;
}

//判断对象是否为空
export let isEmpty = (obj) => (Object.keys(obj).length === 0) ? true : false;

export function parseQuery() {
  const res = {};

  const query = (location.href.split("?")[1] || "")
    .trim()
    .replace(/^(\?|#|&)/, "");

  if (!query) {
    return res;
  }

  query.split("&").forEach(param => {
    const parts = param.replace(/\+/g, " ").split("=");
    const key = decodeURIComponent(parts.shift());
    const val = parts.length > 0 ? decodeURIComponent(parts.join("=")) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res;
}

// 少三位字符戳-转时间-年-月-日
export function timeFn(val, type) {
  if (!val) return val || '';
  let timeNum = Number(val + '000');
  let y = new Date(timeNum).getFullYear();
  let h = new Date(timeNum).getMonth()+1;
  h = h < 10 ? '0'+h : h;
  let m = new Date(timeNum).getDate();
  m = m < 10 ? '0'+m : m;
  let _type = type || '.';
  let timeText = y + _type + h + _type + m;
  return timeText;
}

const VUE_APP_API_URL = process.env.VUE_APP_API_URL || `${location.origin}/api`;
const VUE_APP_WS_URL =
  process.env.VUE_APP_WS_URL || `ws:${location.hostname}:20003`;

export { VUE_APP_API_URL, VUE_APP_WS_URL };
